import React from 'react';
import { Direction, Slider } from 'react-player-controls';
import config from './config.json';

const bgColor = config.backgroundColor
const WHITE_SMOKE = '#eee';
const GRAY = '#878c88';

interface _ProgressBar {
  value: number;
  onChangeValue: (value: number) => void;
  direction?: "HORIZONTAL" | "VERTICAL";
  style?: any
}

const SliderBar = ({  value, style, direction }) => (
  <div
    style={Object.assign(
      {
        position: 'absolute',
        background: GRAY,
        borderRadius: 4,
       
      },
      direction === Direction.HORIZONTAL ? {
        top: 0,
        bottom: 0,
        left: 0,
        width: `${value * 100}%`,
      } : {
        right: 0,
        bottom: 0,
        left: 0,
        height: `${value * 100}%`,
      },
      style
    )}
  />
);

const SliderHandle = ({ value, style, direction }) => (
  <div
    style={Object.assign(
      {
        position: 'absolute',
        width: 16,
        height: 16,
        background: bgColor,
        borderRadius: '100%',
        transform: 'scale(1)',
        transition: 'transform 0.2s',
        '&:hover': {
          transform: 'scale(1.3)',
        },
        
      },
      direction === Direction.HORIZONTAL ? {
        top: 0,
        left: `${value * 100}%`,
        marginTop: -4,
        marginLeft: -8,
      } : {
        left: 0,
        bottom: `${value * 100}%`,
        marginBottom: -8,
        marginLeft: -3,
      },
      style
    )}
  />
);

const ProgressBar = ({  value, onChangeValue, direction=Direction.HORIZONTAL, style={} }: _ProgressBar) => 
{


  const onChangeEnd = (value) => {
    if(value !== null){
      onChangeValue(value)
    }
  }

  const onChange = (value: number) => {
    if(value !== null){
      onChangeValue(value)
    }
  }
  

  return(
  
    <Slider
      isEnabled={true}
      direction={direction}
      onChange={onChange}
      onChangeEnd={onChangeEnd}
      style={{
        width: '100%',
        height: 8,
        borderRadius: 4,
        background: WHITE_SMOKE,
        transition:  'width 0.1s',
        cursor: 'pointer',
        ...style,
    
      }}
    >
      <SliderBar value={value} direction={direction} style={{ background: bgColor }} />
      <SliderHandle  value={value} direction={direction} style={{ background: bgColor }} />
    </Slider>
  );
}



export default ProgressBar